import React, { useState, useEffect, useRef } from 'react';
import './Menu.css';

const menuTabs = [
  { id: 'classic', label: '经典系列' },
  { id: 'soup', label: '汤面系列' },
  { id: 'dry', label: '拌面系列' },
  { id: 'special', label: '特色小吃' }
];

const menuItemsData = [
  {
    category: 'classic',
    image: 'https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=400&q=80',
    name: '红烧牛肉面',
    price: '38',
    description: '秘制红烧牛肉配手工拉面',
    tags: ['招牌', '辣度可选']
  },
  {
    category: 'classic',
    image: 'https://images.unsplash.com/photo-1585032226651-759b368d7246?w=400&q=80',
    name: '川味担担面',
    price: '28',
    description: '麻辣鲜香，肉末酱汁',
    tags: ['辣', '川菜经典']
  },
  {
    category: 'soup',
    image: 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=400&q=80',
    name: '老母鸡汤面',
    price: '32',
    description: '整鸡熬制，汤鲜味美',
    tags: ['养生', '滋补']
  },
  {
    category: 'soup',
    image: 'https://images.unsplash.com/photo-1552611052-33e04de081de?w=400&q=80',
    name: '酸菜鱼片面',
    price: '45',
    description: '鲜嫩鱼片，酸辣开胃',
    tags: ['辣', '招牌']
  },
  {
    category: 'dry',
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&q=80',
    name: '陕西油泼面',
    price: '26',
    description: '热油泼辣，面香四溢',
    tags: ['辣', '西北风味']
  },
  {
    category: 'dry',
    image: 'https://images.unsplash.com/photo-1506354666786-959d6d497f1a?w=400&q=80',
    name: '老北京炸酱面',
    price: '30',
    description: '五花肉丁，秘制酱料',
    tags: ['京味', '经典']
  },
  {
    category: 'special',
    image: 'https://images.unsplash.com/photo-1556909114-44e3e70034e2?w=400&q=80',
    name: '手工锅盔',
    price: '12',
    description: '酥脆掉渣，面香扑鼻',
    tags: ['小吃', '每日限量']
  },
  {
    category: 'special',
    image: 'https://images.unsplash.com/photo-1541167760496-1628856ab772?w=400&q=80',
    name: '古法糖水',
    price: '15',
    description: '银耳莲子 / 红豆沙',
    tags: ['甜品', '养生']
  }
];

const Menu = () => {
  const [activeTab, setActiveTab] = useState('classic');
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const filteredItems = menuItemsData.filter(
    item => activeTab === 'all' || item.category === activeTab
  );

  return (
    <section id="menu" className="menu" ref={sectionRef}>
      <div className="menu-header-bg">
        <img src="https://images.unsplash.com/photo-1552611052-33e04de081de?w=1920&q=80" alt="菜单背景" />
      </div>
      <div className="section-header">
        <span className="section-label">招牌推荐</span>
        <h2 className="section-title">匠心面食</h2>
        <div className="section-decor">
          <span></span>
          <span>◆</span>
          <span></span>
        </div>
      </div>
      <div className="menu-container">
        <div className="menu-tabs">
          {menuTabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="menu-grid">
          {filteredItems.map((item, index) => (
            <div
              key={index}
              className="menu-item"
              data-category={item.category}
              style={{
                opacity: 0,
                transform: 'translateY(30px)',
                transition: `all 0.5s ease ${index * 0.05}s`
              }}
            >
              <div className="item-image">
                <img src={item.image} alt={item.name} loading="lazy" />
              </div>
              <div className="item-content">
                <div className="item-header">
                  <h3>{item.name}</h3>
                  <span className="item-price">¥{item.price}</span>
                </div>
                <p className="item-desc">{item.description}</p>
                <div className="item-tags">
                  {item.tags.map((tag, tagIndex) => (
                    <span
                      key={tagIndex}
                      className={`tag ${tag === '辣' ? 'hot' : ''}`}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Menu;
